import selectRoot from "./root"

export default function selectEntities(state) {
  const root = selectRoot(state)
  return root.entities
}
